import { registerSW } from 'virtual:pwa-register';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { createRouter, RouterProvider } from '@tanstack/react-router';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './styles/globals.css';
import { handleServiceWorkerUpdate } from '@/lib/sw-update';
import { routeTree } from './routeTree.gen';

// Register the PWA service worker. In `autoUpdate` mode (vite.config) the
// plugin reloads the page as soon as a newly deployed worker activates, unless
// `onNeedReload` is given — and an unguarded reload wipes a live conversation.
// handleServiceWorkerUpdate only reloads while the student has written nothing.
registerSW({ immediate: true, onNeedReload: () => handleServiceWorkerUpdate() });

const queryClient = new QueryClient({
	defaultOptions: {
		queries: {
			staleTime: 60_000,
			refetchOnWindowFocus: false,
		},
	},
});

const router = createRouter({
	routeTree,
	context: { queryClient },
	defaultPreload: 'intent',
	scrollRestoration: true,
});

declare module '@tanstack/react-router' {
	interface Register {
		router: typeof router;
	}
}

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('root element not found');

createRoot(rootEl).render(
	<StrictMode>
		<QueryClientProvider client={queryClient}>
			<RouterProvider router={router} />
		</QueryClientProvider>
	</StrictMode>,
);
